import React, { useEffect, useRef, useState } from "react";
import Sidebar from "../Components/Sidebar";
import Header from "../Components/Header";
import { Link, NavLink } from "react-router-dom";
import Select from "react-select";
import "react-datetime/css/react-datetime.css";
import { Nav, Tab, Row, Col, Modal } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { useSelector } from "react-redux";
import useAxiosFile from "../actions/useaxios";
import { DateTimeForm, EncryptData, NumberChange, isEmpty } from "../actions/common";
import { toast } from "react-toastify";
import { socket } from "../services/socket";
import { getUserId } from "../services/commonFuntion";
import QrReader from 'react-qr-reader';
import nodataimage from '.././assets/images/nodata.png'
import { IoMdCloseCircle } from "react-icons/io";
import config from "../actions/config"

function Orders() {
  const { toggle, payload, token } = useSelector(
    (state) => state.seller_panel.User
  );

  const axiosFile = useAxiosFile();

  const [selectedOption, setSelectedOption] = useState(null);
  const [TabName, SetTabName] = useState("neworder");
  const [showModal, SetShowModal] = useState(false)
  const [data, setData] = useState('No result');
  const [PackNumber, setPackNumber] = useState([]);
  const [orderdata, setOrderData] = useState([]);
  const [position, setposition] = useState(false);
  const [number, setnumber] = useState('');
  const [confirmmodel, setconfirmmodel] = useState(false);
  const [alertmodel, setalertmodel] = useState(false);
  const [submit, setsubmit] = useState(false);
  const [imagesshow, setimagesshow] = useState(false);
  const [images, setimages] = useState([]);



  const [Tabdatas, SetTabDatas] = useState({
    neworder: { page: 1, loader: true, data: [] },
  });
  const [shoplist, SetShopList] = useState([]);
  const [currentShop, SetCurrentShop] = useState({ label: "", value: "" });
  const handleClose = () => {
    SetShowModal(false);
  }

  const handlecomfirmClose = () => {
    setconfirmmodel(false);
  }
  const handlealertClose = () => {
    setalertmodel(false);
  }
  const HandleShowModal = (data) => {
    SetShowModal(true);

  }
  const handleshowClose = () => {
    setimagesshow(false);
  }
  const Submit = (data, type, from) => {
    // console.log("orderdataorderdata", data, from);
    setsubmit(true)
    if (from == 'scanner') {
      if (PackNumber?.length > 0) {
        OrderAction(data, type)

      } else {
        toast.error("Enter the package numbers")

        // HandleShowModal()

      }
      setsubmit(false)

    }
    else {
      OrderAction(data, type)
      setsubmit(false)

    }


  }
  const handleScan = (e) => {
    if (!isEmpty(e) && !PackNumber.includes(e)) {
      if (Array.isArray(e)) {
        setPackNumber([...PackNumber, ...e.replace(/\s+/g, '')])
      }
      else {
        setPackNumber([...PackNumber, ...Array(e.replace(/\s+/g, ''))])

      }
    }

  };
  const handleChange = (e) => {

    if (e?.length > 20) {
      return toast.error("Only 20 charcters are allowed...!")
    }

    if (!isEmpty(e) && !PackNumber.includes(e)) {
      if (Array.isArray(e)) {
        setPackNumber([...PackNumber, ...e.replace(/\s+/g, '')])
      }
      else {
        setPackNumber([...PackNumber, ...Array(e.replace(/\s+/g, ''))])

      }
    }
    setnumber('')

  };
  const Cancelpackage = (index) => {
    setPackNumber([
      ...PackNumber.slice(0, index),
      ...PackNumber.slice(index + 1, PackNumber?.length),


    ])

  }
  const stylesgraybg = {
    option: (styles, { isFocused, isSelected, isHovered }) => ({
      ...styles,
      color: "#6C6A81",
      background: isFocused
        ? "#F5F6F7"
        : isSelected
          ? "#F5F6F7"
          : isHovered
            ? "red"
            : "#F5F6F7",

      zIndex: 1,
      cursor: "pointer",
      fontSize: "13px",
    }),

    option: (styles, { isFocused, isSelected, isHovered }) => {
      // const color = chroma(data.color);

      return {
        ...styles,
        backgroundColor: isHovered
          ? "#a71d24"
          : isSelected
            ? "#a71d24"
            : isFocused
              ? "#a71d24"
              : "",
        cursor: "pointer",
        color: isHovered
          ? "#fff"
          : isSelected
            ? "#fff"
            : isFocused
              ? "#fff"
              : "",
        fontSize: "13px",
      };
    },
    valueContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      padding: "0 20px",
      backgroundColor: "#fff ",
      border: "1px solid lightgray",
      borderRadius: 10,
      fontSize: "13px",
    }),
    control: (provided, state) => ({
      ...provided,
      height: "40px",
      borderRadius: 10,
      backgroundColor: "#fff",
      border: "none",
      outline: "none",
      boxShadow: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      position: "absolute",
      right: 0,
      top: 0,
      color: "#6C6A81",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "#6C6A81",
    }),
    menuList: (base) => ({
      ...base,
      // kill the white space on first and last option
      padding: 0,
    }),
  };

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) {
      console.log("page", page);
      console.log("sizePerPage", sizePerPage);
    },
    onSizePerPageChange: function (page, sizePerPage) {
      console.log("page", page);
      console.log("sizePerPage", sizePerPage);
    },
  });

  const columns = [
    { dataField: "OrderNumber", text: "Order Id" },
    // {dataField:"vendorName",text:"Vendor Name",sort:true},
    {
      dataField: "UserId",
      text: "Customer Name",
      sort: false,
      formatter: (cell, val) => (
        <div>
          {cell?.FirstName
            ? cell?.FirstName + " " + cell?.LastName
            : cell?.EmailId}
        </div>
      ),
    },
    {
      dataField: "Price",
      text: "Items",
      sort: false,
      formatter: (cell, row) => <div>{cell?.totalItems}</div>,
    },
    {
      dataField: "Price",
      text: "Type",
      sort: false,
      formatter: (cell, row) => <div>{cell?.Type}</div>,
    },
    // {dataField:"operationtime",text:"Operation Time",sort:true},

    // {
    //   dataField: "TransactionHistory",
    //   text: "Payment",
    //   sort: true,
    //   formatter: (cell, row) => (
    //     <div>
    //       {cell?.object?.payment_method_types?.[0]
    //         ? cell?.object?.payment_method_types?.[0]
    //         : "card"}
    //     </div>
    //   ),
    // },
    {
      dataField: "DeliveryTime",
      text: "Delivery Time",
      sort: true,
      formatter: (cell, row) => (
        <div>{DateTimeForm(cell, null, null, true)}</div>
      ),
    },
    // {
    //   dataField: "Price",
    //   text: "Amount",
    //   sort: true,
    //   formatter: (cell, row) => (
    //     <div>
    //       {console.log("lskfjsfs", row)}
    //       {row?.ShopId?.CurrencySymbol}{" "}
    //       {
    //         (NumberChange(cell?.CartValue) + NumberChange(cell?.Taxes) - NumberChange(cell?.discountPrice) + NumberChange(cell?.SellerTipsInValue)).toFixed(2)
    //       }
    //       {/* {cell?.PayAmount ? Number(cell?.PayAmount).toFixed(2) : "0"} */}
    //     </div>
    //   ),
    // },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, val) => (
        <div class="dropdown table_viewdropdown">
          <button
            class="btn table_viewdrop dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="fa-solid fa-ellipsis" />
          </button>
          <ul class="dropdown-menu men_indi_tab">
            <li>
              <Link
                class="dropdown-item"
                to={`/orderdetail?id=${EncryptData(val?._id)}`}
              >
                View
              </Link>
            </li>
            {isEmpty(val?.Time?.ApprovedBySeller) &&
              isEmpty(val?.Time?.cancelbyseller) &&
              isEmpty(val?.Time?.returned) && (
                <>
                  <li>
                    <hr class="dropdown-divider" />
                  </li>
                  <li onClick={() => OrderAction(val, "approvebyseller")}>
                    <Link class="dropdown-item" to="">
                      Accept
                    </Link>
                  </li>
                </>
              )}
            {!isEmpty(val?.Time?.ApprovedBySeller) &&
              isEmpty(val?.Time?.cancelbyseller) &&
              isEmpty(val?.Time?.Dispatch) &&
              isEmpty(val?.Time?.preparing) &&
              isEmpty(val?.Time?.returned) && (
                <>
                  <li>
                    <hr class="dropdown-divider" />
                  </li>
                  <li onClick={() => OrderAction(val, "preparing")}>
                    <Link class="dropdown-item" to="">
                      Preparing
                    </Link>
                  </li>
                </>
              )}
            {!isEmpty(val?.Time?.ApprovedBySeller) &&
              isEmpty(val?.Time?.Dispatch) &&
              isEmpty(val?.Time?.cancelbyseller) &&
              isEmpty(val?.Time?.returned) && (
                <>
                  <li>
                    <hr class="dropdown-divider" />
                  </li>
                  {val?.OrderType == 'Pickup' ?
                    <li onClick={() => OrderAction(val, "picked")}>
                      <Link class="dropdown-item" to="">
                        Order Is Ready
                      </Link>
                    </li>
                    :
                    <li onClick={() => { setconfirmmodel(true); setOrderData(val) }}>
                      <Link class="dropdown-item" to="">
                        Order Is Ready
                      </Link>
                    </li>}{""}
                </>
              )}
            {val?.Time?.Dispatch &&
              isEmpty(val?.Time?.completed) &&
              isEmpty(val?.Time?.Shipping) &&
              isEmpty(val?.Time?.Pickup) &&
              isEmpty(val?.Time?.returned) && (
                <>
                  <li>
                    <hr class="dropdown-divider" />
                  </li>
                  <li onClick={() => OrderAction(val, "picked")}>
                    <Link class="dropdown-item" to="">
                      Pickup
                    </Link>
                  </li>
                </>
              )}
            {isEmpty(val?.Time?.Dispatch) &&
              isEmpty(val?.Time?.cancelbyseller) &&
              isEmpty(val?.Time?.returned) && (
                <>
                  <li>
                    <hr class="dropdown-divider" />
                  </li>
                  <li onClick={() => OrderAction(val, "cancelbyseller")}>
                    <Link class="dropdown-item" to="">
                      <p className="drpdw_redtxt">Cancel Order</p>
                    </Link>
                  </li>
                </>
              )}
          </ul>
        </div>
      ),
    },
    {
      dataField: "val",
      text: "View images",
      sort: true,
      formatter: (cell, val) => (
        <>
          {console.log("valvalval", val)
          }
          {

            <>
              <button
                className=" mt-0 blue_btn add_deliveryprsn dp_btn_hover"
                onClick={() => { setimagesshow(true); setimages(val?.Attachments) }}
                type="button"
              >

                {/* <p onClick={()=>{HandleShowModal(val);}}> */}
                View images
                {/* </p> */}
              </button>
            </>


          }

        </>
      ),
    },

  ];

  useEffect(() => {
    socket.on(getUserId(), (data) => {
      console.log("emit done", data);
      if (data.type && data.type === 'order') {
        GetOrderList(1, TabName);
      }
    })
  }, [socket])


  useEffect(() => {
    Tabdatas[TabName] = { page: 1, data: [], loader: false };
    SetTabDatas(Tabdatas);
    GetOrderList(1, TabName);
  }, [TabName]);

  useEffect(() => {
    if (currentShop?.value) {
      GetOrderList();
    }
  }, [currentShop?.value]);

  useEffect(() => {
    if (payload?._id) {
      GetShoplist();
    }
  }, [payload?._id]);

  const GetShoplist = async () => {
    let Resp = await axiosFile.getshop({ SellerId: payload._id });
    SetShopList(Resp?.data);
    if (Resp?.data?.length > 0) {
      SetCurrentShop({
        label: Resp?.data[0]?.label,
        value: Resp?.data[0]?.value,
      });
    }
  };


  const handleError = (data) => {
    console.log(
      "handleErrorhandleError", data
    );
  }

  const GetOrderList = async (page, tab) => {
    let senddata = {
      page: (page ? page : Tabdatas[TabName]?.page) ?? 1,
      TabName: tab ? tab : TabName,
      limit: 500,
      UserId: payload?._id,
      ShopId: currentShop?.value,
      Type: "seller",
    };
    let Resp = await axiosFile.GetOrders(senddata);

    if (senddata.page == 1) {
      SetTabDatas({
        ...Tabdatas,
        ...{
          [TabName]: {
            data: Resp?.data,
            page: page,
            loader: Resp?.data?.length > 0 ? true : false,
          },
        },
      });
    } else {
      SetTabDatas({
        ...Tabdatas,
        ...{
          [TabName]: {
            data: [...Tabdatas[TabName].data, ...Resp?.data],
            page: page,
            loader: Resp?.data?.length > 0 ? true : false,
          },
        },
      });
    }
  };

  const ShopChange = (e) => {
    if (e?.value) {
      SetCurrentShop({ label: e.label, value: e.value });
      SetTabDatas({ [TabName]: { page: 1, loader: true, data: [] } });
    }
  };
  const Switchcamera = () => {
    setposition(!position);
    SetShowModal(false)
    setTimeout(() => {
      SetShowModal(true)

    }, 200);
  }

  const OrderAction = async (val, action) => {
    handleClose()
    const id = toast.loading("Updating...");

    if (
      action == "picked" &&
      isEmpty(val?.Driver) &&
      val?.OrderType == "Delivery"
    ) {
      return toast.update(id, {
        render: "Delivery Partner Not Assigned",
        autoClose: 1000,
        type: "error",
        isLoading: false,
      });
    }

    let senddata = {
      OrderId: val._id,
      Status: action,
      packageNumber: PackNumber,
      sealed: PackNumber.length == 0 ? false : true
    };

    let Resp = await axiosFile.OrderStatusUpdate(senddata);
    if (Resp?.success == "success") {
      toast.update(id, {
        render: "Status Updated Successfully",
        type: "success",
        isLoading: false,
        autoClose: 1000,
      });
    } else {
      toast.update(id, {
        render: Resp.msg,
        type: "error",
        isLoading: false,
        autoClose: 1000,
      });
    }
    GetOrderList(1, TabName);
    handlealertClose()
    handlecomfirmClose()
  };
  // const Orderpacking=(data)=>{

  //   HandleShowModal(); 

  //   setOrderData(data)

  // }

  return (
    <>


      <section id="content-wrapper">
        <div class="row">
          <div className="top_title_sec">
            <div>
              <p className="page_title">Orders</p>
            </div>
            <div className="rightside">
              {/* <div className='order_calendar_div'>
                              <p>Start Date</p>
                              <img className='order_calendar_ic' src={require('../assets/images/icons/calendar.png')}/>
                              <Datetime className='order_datepick'/>
                            </div>

                            <p className='order_totxt'>To</p>
                            <div className='order_calendar_div'>
                              <p>End Date</p>
                              <img className='order_calendar_ic' src={require('../assets/images/icons/calendar.png')}/>
                              <Datetime className='order_datepick'/>
                            </div> */}
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="sec_border">
            <div className="row">
              {/* <div className='col-xxl-4 col-xl-4 col-lg-3 col-md-3 col-sm-12 col-12'>
          <div className='whole_searchbar white_bg'>
     
    <input placeholder="Search term"/>
     </div>
          </div> */}

              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                <Select
                  // menuIsOpen={true}
                  className="cust_rct_slt"
                  options={shoplist}
                  onChange={(e) => {
                    ShopChange(e);
                  }}
                  value={currentShop}
                  styles={stylesgraybg}
                />
              </div>
              
                          <div className="orders_tabs ">
                            <Tab.Container
                              id="left-tabs-example"
                              defaultActiveKey={TabName}
                            >
                              <Row>
                                <Col sm={12}>
                                  <Nav
                                    variant="pills"
                                    className="flex orders_tabs pb-2"
                                  >
                                    <Nav.Item>
                                      <Nav.Link
                                        className="order_orangetab"
                                        eventKey="neworder"
                                        onClick={() => SetTabName("neworder")}
                                      >
                                        New orders
                                        {/* <span className='orders_tabpop orange_tabbg'>5</span> */}
                                      </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                      <Nav.Link
                                        className="order_violettab"
                                        eventKey="upcomingorder"
                                        onClick={() =>
                                          SetTabName("upcomingorder")
                                        }
                                      >
                                        Upcoming orders
                                        {/* <span className='orders_tabpop violet_tabbg'>5</span> */}
                                      </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                      <Nav.Link
                                        className="order_bluetab"
                                        eventKey="approvebyseller"
                                        onClick={() =>
                                          SetTabName("approvebyseller")
                                        }
                                      >
                                        Accepted
                                        {/* <span className='orders_tabpop blue_tabbg'>5</span> */}
                                      </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                      <Nav.Link
                                        className="order_blurbluetab"
                                        eventKey="preparing"
                                        onClick={() => SetTabName("preparing")}
                                      >
                                        Preparing
                                        {/* <span className='orders_tabpop blurblue_tabbg'>5</span>  */}
                                      </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                      <Nav.Link
                                        className="order_skybluetab"
                                        eventKey="dispatch"
                                        onClick={() => SetTabName("dispatch")}
                                      >
                                        Dispatched
                                        {/* <span className='orders_tabpop  skyblue_tabbg'>5</span> */}
                                      </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                      <Nav.Link
                                        className="order_orangetab"
                                        eventKey="shipping"
                                        onClick={() => SetTabName("shipping")}
                                      >
                                        Out for Delivery
                                        {/* <span className='orders_tabpop  orange_tabbg'>5</span> */}
                                      </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                      <Nav.Link
                                        className="order_greentab"
                                        eventKey="completed"
                                        onClick={() => SetTabName("completed")}
                                      >
                                        Completed
                                        {/* <span className='orders_tabpop green_tabbg'>5</span> */}
                                      </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                      <Nav.Link
                                        className="order_redtab"
                                        eventKey="cancelbyseller"
                                        onClick={() =>
                                          SetTabName("cancelbyseller")
                                        }
                                      >
                                        Cancel
                                        {/* <span className='orders_tabpop  red_tabbg'>5</span> */}
                                      </Nav.Link>
                                    </Nav.Item>
                                  </Nav>
                                </Col>
                                <Col sm={12}>
                                  <Tab.Content>

                                    {Tabdatas[TabName]?.data?.length > 0 ? (
                                      <Tab.Pane eventKey={TabName}>
                                        <div className="ffd_table row orders_altable ">
                                          <BootstrapTable
                                            bootstrap4
                                            keyField="id"
                                            columns={columns}
                                            data={Tabdatas?.[TabName]?.data}
                                            pagination={pagination}
                                            noDataIndication="No Order found"
                                          />
                                        </div>
                                      </Tab.Pane>
                                    ) :
                                      <div className="no_data_found d-flex flex-column mx-auto">
                                        {/* <img src={nodataimage} style={{ width: "50px" }} /> */}
                                        <p className="text-center pt-4 pb-3">No Order found</p>
                                      </div>
                                    }
                                    {/* <Tab.Pane eventKey="second">
            <div className='ffd_table'>
          <BootstrapTable bootstrap4 keyField='id' columns={schedulecolumns} data={scheduleddata} pagination={pagination}/>
          </div>
            </Tab.Pane>
            <Tab.Pane eventKey="third">
            <div className='ffd_table'>
          <BootstrapTable bootstrap4 keyField='id' columns={acceptedcolumns} data={accepteddata} pagination={pagination}/>
          </div> 
            </Tab.Pane>

            <Tab.Pane eventKey="fourth">
            <div className='ffd_table'>
          <BootstrapTable bootstrap4 keyField='id' columns={preparecolumns} data={preparedata} pagination={pagination}/>
          </div> 
            </Tab.Pane>
            <Tab.Pane eventKey="fifth">
            <div className='ffd_table'>
          <BootstrapTable bootstrap4 keyField='id' columns={orderreadyecolumns} data={orderreadydata} pagination={pagination}/>
          </div> 
            </Tab.Pane>
            <Tab.Pane eventKey="sixth">
            <div className='ffd_table'>
          <BootstrapTable bootstrap4 keyField='id' columns={intransitcolumns} data={intransitdata} pagination={pagination}/>
          </div> 
            </Tab.Pane>
            <Tab.Pane eventKey="seventh">
            <div className='ffd_table'>
          <BootstrapTable bootstrap4 keyField='id' columns={completedcolumns} data={completeddata} pagination={pagination}/>
          </div>
            </Tab.Pane>
            <Tab.Pane eventKey="eight">
            <div className='ffd_table'>
          <BootstrapTable bootstrap4 keyField='id' columns={cancelcolumns} data={canceldata} pagination={pagination}/>
          </div>
            </Tab.Pane> */}
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
              </div>
            </div>
          </div>
        </div>
      </section>



      {
        showModal &&
        <Modal
          show={showModal}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          centered
          className="reg_gender_modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: "18px" }}>
              Scan the Qr code to add the package number
            </Modal.Title>
            {/* <Modal.Title></Modal.Title> */}

          </Modal.Header>
          <Modal.Body>


            <QrReader
              delay={1000}
              onError={handleError}
              onScan={(e) => handleScan(e)}
              style={{ width: '100%', height: "100%" }}
              constraints={{ facingMode: position ? 'environment' : "user" }}

            />


            <div className="rv_rowborder mt-3">
              {/* {PackNumber?.map((item) =>
            <text>{item}</text>
          )
          } */}
              <div className="d-flex align-items-center gap-2 flex-wrap scantagsec ">
                {PackNumber?.map((item, index) =>
                  <p className="mb-0 labeltags">{item} <IoMdCloseCircle className="closeicons" onClick={() => Cancelpackage(index)} /></p>
                )
                }

              </div>
              <div className="text-center">
                <p>
                  Enter Manually
                </p>
                <div className="d-flex align-items-center gap-3 justify-content-center mb-3">

                  <input type="text" value={number} onChange={(e) => setnumber((e.target.value).trim())} maxLength={50} />
                  {
                    <button
                      className="blue_btn add_deliveryprsn mt-0 dp_btn_hover ml-2"
                      type="button"
                      onClick={() => handleChange(number)}
                    >
                      Add
                    </button>
                  }
                </div>

              </div>

              <div className="text-center">
                {
                  <button
                    className="blue_btn add_deliveryprsn mt-0 dp_btn_hover me-3"
                    type="button"
                    onClick={() => !submit && Submit(orderdata, 'dispatch', 'scanner')}
                  >
                    Confirm
                  </button>
                }
                {
                  <button
                    className="blue_btn add_deliveryprsn mt-0  dp_btn_hover"
                    type="button"
                    onClick={() => { Switchcamera() }}
                  >
                    Switch camera
                  </button>
                }
              </div>
            </div>
          </Modal.Body>
        </Modal>
      }


      {
        confirmmodel &&
        <Modal
          show={confirmmodel}
          onHide={handlecomfirmClose}
          backdrop="static"
          keyboard={false}
          centered
          className="reg_gender_modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: "18px" }}>
              Order for Delivery
            </Modal.Title>

          </Modal.Header>
          <Modal.Body>

            <div className="rv_rowborder mt-3">



              <div className="text-center">
                {
                  <button
                    className="blue_btn add_deliveryprsn mt-0 dp_btn_hover me-3"
                    type="button"
                    onClick={() => { SetShowModal(true); handlecomfirmClose() }}
                  >
                    Scan the Qr
                  </button>
                }
                {
                  <button
                    className="blue_btn add_deliveryprsn mt-0 dp_btn_hover me-3"
                    type="button"
                    onClick={() => { setalertmodel(true); handlecomfirmClose() }}
                  >
                    Dispatch
                  </button>
                }

              </div>
            </div>
          </Modal.Body>
        </Modal>
      }
      {
        alertmodel &&
        <Modal
          show={alertmodel}
          onHide={handlealertClose}
          backdrop="static"
          keyboard={false}
          centered
          className="reg_gender_modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: "18px" }}> Your item will be packed by the delivery person,Are you sure want to confirm?
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>


            <div className="rv_rowborder mt-3">



              <div className="text-center">
                {
                  <button
                    className="blue_btn add_deliveryprsn mt-0 dp_btn_hover me-3"
                    type="button"
                    onClick={() => !submit && Submit(orderdata, 'dispatch', 'manual')}
                  >
                    Confirm
                  </button>
                }
                {
                  <button
                    className="blue_btn add_deliveryprsn mt-0  dp_btn_hover"
                    type="button"
                    onClick={() => { handlealertClose() }}
                  >
                    Cancel
                  </button>
                }
              </div>
            </div>
          </Modal.Body>
        </Modal>
      }


      <Modal
        show={imagesshow}
        onHide={handleshowClose}
        backdrop="static"
        keyboard={false}
        centered
        className="reg_gender_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Verify Images</Modal.Title>

        </Modal.Header>
        <Modal.Body>
          <div className="d-flex gap-3 justify-content-center flex-wrap">
            {images?.length > 0 ?
              images?.map((item) =>
                // <div className="rv_rowborder mt-3 text-center">

                <img className="img-fluid sellerviewimg verifyimg" src={`${config?.IMG_URL}/verifyimages/${item}`} />

                // </div>
              )
              :
              <>No Data Found</>

            }
          </div>

        </Modal.Body>
      </Modal>
    </ >
  );
}

export default Orders;
